import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.number.constructor";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { API_REQUEST } from '@/api';
import { CACHE_REGENERATE_TIME } from '@/config/exchange';

function getUpdateVacancyRequest(_ref) {
  var rootState = _ref.rootState,
      rootGetters = _ref.rootGetters,
      pageNumber = _ref.pageNumber,
      limit = _ref.limit;
  var depId = rootState.queryMirrored.deps;
  var offset = (pageNumber - 1) * limit;
  var request = {
    shop_id: depId,
    offset: offset,
    limit: limit,
    dt_from: rootState.queryMirrored.from,
    dt_to: rootState.queryMirrored.to,
    is_fact: false
  };
  var mainWorkTypes = rootState.queryMirrored.mainWorkTypes;

  if (mainWorkTypes) {
    request.work_type_name = mainWorkTypes;
  }

  var vacancyFilterFree = rootState.queryMirrored.vacancyFilterFree;

  if (vacancyFilterFree) {
    request.is_vacant = vacancyFilterFree === 'free' ? true : vacancyFilterFree === 'not-free' ? false : undefined;
  }

  var vacancyFilterApproved = rootState.queryMirrored.vacancyFilterApproved;

  if (vacancyFilterApproved) {
    request.is_approved = vacancyFilterApproved === 'approved' ? true : vacancyFilterApproved === 'not-approved' ? false : undefined;
  }

  if (rootGetters['user/isUserClient'] && +rootState.queryMirrored.internalExchange === 1) {
    request.is_outsource = false;
  } else if (!rootGetters['user/isUserClient'] && +rootState.queryMirrored.includeOutsource === 1) {
    request.is_outsource = true;
  }

  if (!(+rootState.queryMirrored.internalExchange === 1) && !!rootState.queryMirrored.outsourcingsVacancyExchange) {
    request.outsourcing_network_id__in = String(rootState.queryMirrored.outsourcingsVacancyExchange);
  }

  request['approved_first'] = true;
  var isActiveInternalOrOutsources = rootGetters['user/isUserClient'] && +rootState.queryMirrored.internalExchange === 1 || !rootGetters['user/isUserClient'] && +rootState.queryMirrored.includeOutsource === 1;
  var selectedInternalOrOutsourcesIds = rootGetters['queryMirrored/getSelectInternalOrOutsourcesIds'];
  var needToResetVacancies = false;

  if (isActiveInternalOrOutsources) {
    if (rootState.queryMirrored.internalOrOutsourcesIds && selectedInternalOrOutsourcesIds.length > 0) {
      request.shop_id = selectedInternalOrOutsourcesIds;
    } else {
      needToResetVacancies = true;
    }
  }

  return {
    request: request,
    needToResetVacancies: needToResetVacancies
  };
}

var cache = {};
/**
 * @returns {import('./exchange').ExchangeState}
 */

var state = function state() {
  return {
    vacancies: [],
    outsourcingVacancyExchange: []
  };
};

var mutations = {
  setVacancies: function setVacancies(state, value) {
    state.vacancies = value;
  },

  /**
   * @param {import('./exchange').ExchangeStore} state
   * @param {number} index
   */
  deleteVacancy: function deleteVacancy(state, index) {
    state.vacancies.splice(index, 1);
  },
  replaceVacancy: function replaceVacancy(state, newVacancy) {
    var index = state.vacancies.findIndex(function (el) {
      return el.id === newVacancy.id;
    });
    state.vacancies.splice(index, 1, newVacancy);
  }
};
var actions = {
  getEditableVacancy: function getEditableVacancy(context, _ref2) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var approvedId, shopId, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              approvedId = _ref2.approvedId, shopId = _ref2.shopId;
              _context.next = 3;
              return API_REQUEST('getEditableVacancyId', {
                'id': approvedId,
                'shop_id': shopId
              });

            case 3:
              res = _context.sent;
              return _context.abrupt("return", res[1]);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getOutsourcingVacancyExchange: function getOutsourcingVacancyExchange(_ref3) {
    var rootGetters = _ref3.rootGetters;
    var outsourcings = rootGetters['user/outsourcings'].map(function (el) {
      return {
        label: el['name'],
        value: el['id']
      };
    });
    return outsourcings;
  },
  updateVacancies: function updateVacancies(_ref4, _ref5) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var dispatch, commit, rootState, rootGetters, pageNumber, limit, isForce, _getUpdateVacancyRequ, request, needToResetVacancies, key, vacanciesFromServer, error, _yield$API_REQUEST, _yield$API_REQUEST2, _vacanciesFromServer, results, count, uniqueDepIds, promisesRes, workTypes, employeeIds, vacancies;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref4.dispatch, commit = _ref4.commit, rootState = _ref4.rootState, rootGetters = _ref4.rootGetters;
              pageNumber = _ref5.pageNumber, limit = _ref5.limit, isForce = _ref5.isForce;
              _getUpdateVacancyRequ = getUpdateVacancyRequest({
                rootState: rootState,
                rootGetters: rootGetters,
                pageNumber: pageNumber,
                limit: limit
              }), request = _getUpdateVacancyRequ.request, needToResetVacancies = _getUpdateVacancyRequ.needToResetVacancies;

              if (!needToResetVacancies) {
                _context2.next = 6;
                break;
              }

              commit('setVacancies', []);
              return _context2.abrupt("return", {
                count: []
              });

            case 6:
              key = JSON.stringify(request);
              /** @type {import('@/api/api').GetVacancyResponse} */

              if (!(isForce || !cache[key])) {
                _context2.next = 18;
                break;
              }

              _context2.next = 10;
              return API_REQUEST('getVacancies', request);

            case 10:
              _yield$API_REQUEST = _context2.sent;
              _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
              error = _yield$API_REQUEST2[0];
              vacanciesFromServer = _yield$API_REQUEST2[1];
              cache[key] = JSON.parse(JSON.stringify(vacanciesFromServer));
              setTimeout(function () {
                delete cache[key];
              }, CACHE_REGENERATE_TIME);
              _context2.next = 19;
              break;

            case 18:
              vacanciesFromServer = JSON.parse(JSON.stringify(cache[key]));

            case 19:
              if (!error) {
                _context2.next = 21;
                break;
              }

              throw error;

            case 21:
              _vacanciesFromServer = vacanciesFromServer, results = _vacanciesFromServer.results, count = _vacanciesFromServer.count;
              uniqueDepIds = _toConsumableArray(new Set(results.map(function (vacancy) {
                return vacancy.shop_id;
              })));
              _context2.next = 25;
              return Promise.all(uniqueDepIds.map(function (depId) {
                return dispatch('cachedData/getWorkTypes', {
                  byDepId: depId
                }, {
                  root: true
                });
              }));

            case 25:
              promisesRes = _context2.sent;
              workTypes = promisesRes.flat();
              employeeIds = results.map(function (el) {
                return el.employee_id;
              }).filter(function (el) {
                return el;
              }).join();

              if (!employeeIds) {
                _context2.next = 31;
                break;
              }

              _context2.next = 31;
              return dispatch('staff/getEmployees', {
                employeeId: employeeIds
              }, {
                root: true
              });

            case 31:
              vacancies = results.map(function (vacancy) {
                vacancy._workTypes = vacancy.worker_day_details.map(function (details) {
                  var _workTypes$find;

                  return {
                    part: details.work_part,
                    label: (_workTypes$find = workTypes.find(function (item) {
                      return +item.id === +details.work_type_id;
                    })) === null || _workTypes$find === void 0 ? void 0 : _workTypes$find.label
                  };
                });
                return vacancy;
              });
              commit('application/setPrimaryPageLoaded', {
                value: true
              }, {
                root: true
              });
              commit('setVacancies', vacancies);
              return _context2.abrupt("return", {
                count: count
              });

            case 35:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * @deprecated
   */
  replaceVacancy: function replaceVacancy(_ref6, newVacancy) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var dispatch, commit, workTypes, allDepartments, vacancy;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch = _ref6.dispatch, commit = _ref6.commit;
              _context3.next = 3;
              return dispatch('cachedData/getWorkTypes', {
                byDepId: newVacancy.shop_id
              }, {
                root: true
              });

            case 3:
              workTypes = _context3.sent;
              _context3.next = 6;
              return dispatch('cachedData/getAllDepartments', {
                byId: true
              }, {
                root: true
              });

            case 6:
              allDepartments = _context3.sent;
              vacancy = _objectSpread(_objectSpread({}, newVacancy), {}, {
                _workTypes: newVacancy.worker_day_details.map(function (details) {
                  var _workTypes$find2;

                  return {
                    part: details['work_part'],
                    label: (_workTypes$find2 = workTypes.find(function (item) {
                      return Number(item.id) === Number(details['work_type_id']);
                    })) === null || _workTypes$find2 === void 0 ? void 0 : _workTypes$find2.label
                  };
                }),
                shop: allDepartments[newVacancy.shop_id]
              });
              commit('replaceVacancy', vacancy); // update cache

              Object.values(cache).forEach(function (_ref7) {
                var results = _ref7.results;
                var index = results.findIndex(function (el) {
                  return el.id === vacancy.id;
                });
                results.splice(index, 1, JSON.parse(JSON.stringify(vacancy)));
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};
export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  state: state
};